import { eResults, localStorageKeys } from "./enums";
import { Utils } from './utils';

export class BankIdView {

    constructor(showBackButton, useSecuredFlow) {

        this._bankIdNumInput = document.querySelector("#bankIdNumber_input");
        this._rememberMeCheckbox = document.querySelector(".bank-ID__checkbox");
        this._rememberMeTooltip = document.querySelector("#bankIdTooltip");
        this._rememberMeTooltipOverlay = document.querySelector("#bankIdTooltipOverlay");
        this._submitButton = document.querySelector("#submit_button");
        this._submitProgress = document.querySelector("#submit_progress");
        this._customError = document.querySelector("#bankIdCustomError");
        this._customQRError = document.querySelector("#bankIdCustomErrorQR");
        this._backButtonContainer = document.querySelector("#back_button_container");
        this._backButton = document.querySelector("#back_button");
        this._backButtonQR = document.querySelector("#back_button-QR-code");
        this._displayQRButton = document.querySelector("#mmbr-bankID-QR-code");
        this._QRButtonsContainer = document.querySelector("#bankID-QRcta");
        this._QRWrapper = document.querySelector("#bank-ID-QR__wrapper");
        this._bankIdInputs = document.querySelector("#bank-ID__inputs");    
        this._bankIdLogo = document.querySelector("#bank-ID__logo");    
        this._useSecuredFlow = useSecuredFlow;

        this._applicationInfo = document.querySelector("#application_info");
        this._qrCode = document.querySelector("#qrCode");

        if (showBackButton && !useSecuredFlow){
            this.show(this._backButtonContainer);
                                    
            this._backButton.onclick = function() {
                this._backCallback();
            }.bind(this);
        }

        if (this._useSecuredFlow) {
            this.show(this._QRWrapper);
            this.hide(this._bankIdInputs);
        }

        this._backButtonQR.onclick = function () {
            this._backCallback();
        }.bind(this);

        this._displayQRButton.onclick = function () {
            this.hideAllErrors();
            this.hide(this._QRButtonsContainer);

            this._submitCallback(null, (errorCode) => {                
                if (errorCode !== eResults.Ok) {                 
                    this.show(this._QRButtonsContainer);
                    this.showError(errorCode);
                }
            });
        }.bind(this);

        this._bankIdLogo.ondblclick = function () {
            this._onTestBankIdInsertedCallback();
        }.bind(this);

        this._submitCallback = function () { };
        this._backCallback = function () { };
        this._onTestBankIdInsertedCallback = function () { };
        this._onErrorDisplayedCallback = function () { };
        
        this._bankIdNumInput.onChange = function () {
            this.hideAllErrors();
        }.bind(this);
       
        this._submitButton.onclick = function () {

            let bankIdVal = this._bankIdNumInput.value;

            if (bankIdVal === "1234567890") {
                this._onTestBankIdInsertedCallback();
            }

            if (this.isBankIdFormatValid(bankIdVal)) {

                if (this.checkForMinimumAge(bankIdVal)){
                    this.disable(this._bankIdNumInput);
                    this.hide(this._submitButton);
                    this.show(this._submitProgress);
                    this.show(this._applicationInfo);
                    this.hideAllErrors();
                    this.setRememberMeData(bankIdVal);

                    this._submitCallback(bankIdVal, (errorCode) => {
                        this.show(this._submitButton);
                        this.hide(this._submitProgress);
                        this.hide(this._applicationInfo);
                        this.enable(this._bankIdNumInput);

                        if (errorCode === eResults.Ok) {
                            this._bankIdNumInput.value = "";
                        } else {
                            this.showError(errorCode);
                        }
                    });
                }
                else{
                    this.showError(eResults.UnderAge);
                }
            } 
            else {
                this.showError(eResults.InvalidParams);
            }
        }.bind(this);

        this._bankIdNumInput.onkeypress = function (e) {

            if (e.keyCode == 13) { // Enter
                this._submitButton.click();
                e.preventDefault();
            }

        }.bind(this);

        // set a small delay due to client implementation
        this.onVisible(this._bankIdNumInput, () => setTimeout(function () {
            this.getRememberMeData();
        }.bind(this), 100), true);

        this._rememberMeTooltip.onclick = function () {
            document.querySelector(".bank-ID__tooltip").classList.add("show--content");
        }

        this._rememberMeTooltipOverlay.onclick = function () {
            document.querySelector(".bank-ID__tooltip").classList.remove("show--content");
        }
    }

    setRememberMeData(bankId) {
        if (this._rememberMeCheckbox.checked) {
            window.localStorage.setItem(localStorageKeys.bankIdValue, bankId);
        }
        else {
            window.localStorage.removeItem(localStorageKeys.bankIdValue);
        }
    }

    getRememberMeData() {
        const bankIdFromLocalStorage = window.localStorage.getItem(localStorageKeys.bankIdValue);
        if (bankIdFromLocalStorage) {
            this._bankIdNumInput.value = bankIdFromLocalStorage;
            this._rememberMeCheckbox.checked = true;
        }
    }

    isBankIdFormatValid(bankId) {
        // NOTE: same validation checks on BankID format are also performed on server side (IPGW)

        // check if it contains exactly 12 chars, and those chars are all digits:
        if (bankId.length !== 12 || isNaN(bankId)) {
            return false;
        }

        // split its first 8 digits into date components according to format 'yyyyMMdd':
        const bankIdYear = parseInt(bankId.substring(0, 4));
        const bankIdMonth = parseInt(bankId.substring(4, 6));
        const bankIdDay = parseInt(bankId.substring(6, 8));

        const bankIdMonthJs = bankIdMonth - 1 // since the month index in JavaScript is 0-based (0=January)

        // create a new Date object with the bankId date components:
        let date = new Date(1970, 0, 1); //initialize to a valid date
        date.setFullYear(bankIdYear);
        date.setMonth(bankIdMonthJs);
        date.setDate(bankIdDay);

        // check components of Date object against the bankId date components:
        if ((date.getFullYear() != bankIdYear) ||
            (date.getMonth() != bankIdMonthJs) ||
            (date.getDate() != bankIdDay)) {
            // this means the 8 digit prefix of the bankId represent an invalid date in the calendar
            return false;
        }

        // all validation checks passed
        return true;
    }

    checkForMinimumAge(bankIdVal) {
        var dateOfBirth = new Date(bankIdVal.substring(0,4), parseInt(bankIdVal.substring(4,6)) - 1, bankIdVal.substring(6,8));
        var currentDate = new Date();

        return dateOfBirth < currentDate.setFullYear(currentDate.getFullYear() - 18);
    }

    showError(errorCode) {

        this.hideAllErrors();

        if (errorCode !== eResults.Ok) {

            let errorDivId = "#bankIdGeneralError";

            switch (errorCode) {

                case eResults.InvalidParams:
                    errorDivId = "#bankIdInvalidParamError";
                    break;

                case eResults.AuthRequestAlreadyInprogress:
                    errorDivId = "#bankIdInProgressError";
                    break;

                case eResults.ExpiredTransaction:
                    errorDivId = "#bankIdExpiredTransactionError";
                    break;

                case eResults.UserCancel:
                    errorDivId = "#bankIdUserCancelError";
                    break;

                case eResults.CertificateErr:
                    errorDivId = "#bankIdCertificateErrError";
                    break;

                case eResults.UnderAge:
                    errorDivId = "#bankIdUnderAge";
                    break;

                case eResults.Failed:
                    errorDivId = "#bankIdGeneralError";
                    break;

                default:
                    errorDivId = "#bankIdGeneralError";
                    break;
            }

            if (this._useSecuredFlow) {
                errorDivId = errorDivId + 'QR';
            }

            this.show(errorDivId);
            let errMessage = document.querySelector(errorDivId).innerText;

            this._onErrorDisplayedCallback(errorCode, errMessage);
        }
    }

    hideAllErrors() {
        this.hide("#bankIdInvalidParamError");
        this.hide("#bankIdGeneralError");
        this.hide("#bankIdInProgressError");
        this.hide("#bankIdExpiredTransactionError");
        this.hide("#bankIdUserCancelError");
        this.hide("#bankIdCertificateErrError");
        this.hide("#bankIdCustomError");
        this.hide("#bankIdUnderAge");

        this.hide("#bankIdInvalidParamErrorQR");
        this.hide("#bankIdGeneralErrorQR");
        this.hide("#bankIdInProgressErrorQR");
        this.hide("#bankIdExpiredTransactionErrorQR");
        this.hide("#bankIdUserCancelErrorQR");
        this.hide("#bankIdCertificateErrErrorQR");
        this.hide("#bankIdCustomErrorQR");
        this.hide("#bankIdUnderAgeQR");
    }

    hide(elm) {

        if (typeof elm === "string") {
            let e = document.querySelector(elm);
            this.hide(e);
        } else if (elm !== null) {
            elm.classList.add("hide--el");
        }
    }

    show(elm) {

        if (typeof elm === "string") {
            let e = document.querySelector(elm);
            this.show(e);
        } else if (elm !== null) {
            elm.classList.remove("hide--el");
        }
    }

    disable(elm) {
        elm.disabled = true;
    }

    enable(elm) {
        elm.disabled = false;
    }

    onSubmit(callback) {
        this._submitCallback = callback || function () { };
    }

    onBack(callback){
        this._backCallback = callback || function () { };
    }

    onErrorDisplayed(callback) {
        this._onErrorDisplayedCallback = callback || function () { };
    }

    onTestBankIdInserted(callback) {
        this._onTestBankIdInsertedCallback = callback || function () { };
    }

    reset() {
        if (this._useSecuredFlow) {
            this.toggleQRCode(null);
            this.show(this._QRButtonsContainer);
        } else {
            this._bankIdNumInput.value = "";
            this.hideAllErrors();
            this.enable(this._bankIdNumInput);
            this.show(this._submitButton);
            this.hide(this._submitProgress);
            this.hide(this._applicationInfo);
            this.hideAllErrors();
        }
    }

    showCustomError(err) {

        this.hideAllErrors();

        if (this._useSecuredFlow) {
            this._customQRError.innerText = err;
            this.show(this._customQRError);
        } else {
            this._customError.innerText = err;
            this.show(this._customError);
        }
    }

    onVisible(element, callback, keepObserving) {
        new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    callback(element);
                    if (!keepObserving) {
                        observer.disconnect();
                    }
                }
            });
        }).observe(element);
    }

    toggleQRCode(qrCode) {
        if (this._qrCode !== null) {
            if (qrCode) {
                this._qrCode.setAttribute("src", `data:image/svg+xml;base64,${qrCode}`);
                this.show(this._qrCode.parentElement.parentElement);
            }
            else {
                this._qrCode.setAttribute("src", "");
                this.hide(this._qrCode.parentElement.parentElement);
            }
        }
    }
}